import AccountsPage from "features/accountsPage/AccountsPage";
import HomePage from "features/homePage/HomePage";
import LoginPage from "features/loginPage/LoginPage";
import LogoutPage from "features/logoutPage/LogoutPage";
import NotFoundPage from "features/notFoundPage/NotFoundPage";

import { AuthorizedRoute, NotAuthorizedRoute } from "lib/auth";
import { Route, Routes } from "react-router-dom";
import AccountRoutes from "./AccountRoutes";

export default function AppRoutes() {
    return (
        <Routes>
          <Route path="/accounts/:accountId/*" element={<AuthorizedRoute component={<AccountRoutes />} />} />
          <Route path="/accounts" element={<AuthorizedRoute component={<AccountsPage />} />} />
          <Route path="/logout" element={<AuthorizedRoute component={<LogoutPage />} redirect="/home" />} />
          <Route path="/login" element={<NotAuthorizedRoute component={<LoginPage />} />} />
          <Route path="/home" element={<NotAuthorizedRoute component={<HomePage />} redirect="/accounts" />} />
          <Route path="/" element={<NotAuthorizedRoute component={<LoginPage />} redirect="/accounts" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
    )
}